// extracted by mini-css-extract-plugin
export var attachment = "_qe-a";
export var emailContainer = "_qe-4";
export var emailContentPaddedContainer = "_qe-b";
export var emailHeader = "_qe-6";
export var emailIframe = "_qe-3";
export var emailInfoIcon = "_qe-9";
export var emailShortenedSummary = "_qe-e";
export var infoDropdown = "_qe-0";
export var infoRowBoundedContent = "_qe-d";
export var internal = "_qe-5";
export var merchant = "_qe-8";
export var messageInputContainer = "_qe-h";
export var normal = "_qe-7";
export var replyCard = "_qe-f";
export var subtleButton = "_qe-1";
export var subtleButtonIconContainer = "_qe-2";
export var toggleViewRepliesButton = "_qe-c";
export var wrappingText = "_qe-g";